import { FC, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { differenceBy } from 'lodash';

import { UnifiedMitigation, ScenarioUnifiedMitigation } from '../../../../../types';

interface UnifiedMitigationsAutocompleteProps {
  allMitigations: UnifiedMitigation[];
  selectedScenarioMitigations: ScenarioUnifiedMitigation[];
  onSelect: (mitigation: UnifiedMitigation) => void;
}

const UnifiedMitigationsAutocomplete: FC<UnifiedMitigationsAutocompleteProps> = ({
  allMitigations,
  selectedScenarioMitigations,
  onSelect
}) => {
  const [inputValue, setInputValue] = useState<string>('');

  const availableOptions = differenceBy(allMitigations, selectedScenarioMitigations, item =>
    typeof item === 'object' && 'unifiedmitigation' in item ? item.unifiedmitigation : item.id
  );

  return (
    <Autocomplete
      disablePortal
      id="mitigation-select"
      options={availableOptions}
      fullWidth
      value={null}
      inputValue={inputValue}
      onInputChange={(_, value) => setInputValue(value)}
      getOptionLabel={(mitigation: UnifiedMitigation) => mitigation.name}
      renderInput={params => <TextField {...params} label="Search mitigations to add" />}
      onChange={(_, selected) => {
        if (selected) {
          onSelect(selected);
          setInputValue('');
        }
      }}
    />
  );
};

export default UnifiedMitigationsAutocomplete;
